<template>
  <div class="product-card my-4">
    <div class="product-image">
      <i
        class="favorite fa"
        :class="{ 'fa-heart': product.has_favorite, 'fa-heart-o': !product.has_favorite }"
        @click="ToggleFavorite(product)"
      ></i>
      <img
        :src="product.images?.length > 0 ? product.images[0].path : ProductImgDefault"
        :alt="product.name || 'Product Image'"
        class="img-product"
        @click="goToProduct(product)"
        loading="lazy"
      />
    </div>
    <div class="product-info px-0">
      <span class="gamme mb-2">{{ product.gamme_supplyvet ?? "" }}</span>
      <h3 class="title mb-2" @click="goToProduct(product)">{{ product.name }}</h3>

      <div class="desc row mx-0">
        <label class="col col-lg-8 px-0">{{
          product.description != null ? truncateHtmlContent(product.description) : ""
        }}</label>
        <span
          v-if="product.variant && product.variant.currentChannelPricings"
          class="price my-auto col col-lg-4 px-0"
        >
           {{ formatPrice(isClient ? product.variant.price_ttc : product.variant.price_ht) }}
          <span>{{ isClient ? '€ TTC' : '€ HT' }}</span>
        </span>
      </div>
      <button class="btn text-white product-more w-100 mt-2" @click="goToProduct(product)">En savoir plus</button>
    </div>
  </div>
</template>

<script>
  import ProductImgDefault from "@/assets/images/product_default.png";
  import { useProductsStore } from "@/stores/productsStore";
import { useRegisterStore } from '@/stores/register';

  export default {
    name: "ProductCardSlide",
    data() {
      return {
        ProductImgDefault,
      };
    },
    props: {
      product: {
        type: Object,
        required: true,
      },
    },
    created() {
      this.productsStore = useProductsStore();
      this.registerStore = useRegisterStore();
    },

     computed: {
      isClient() {
        return this.registerStore.user?.role === "client";
      },
    },
    methods: {
      ToggleFavorite(prod) {
        prod.has_favorite = !prod.has_favorite;
        if (prod.has_favorite) {
          this.productsStore.AddFavoriteProduct(prod);
        } else {
          this.productsStore.RemoveFavoriteProduct(prod);
        }
      },
      truncateHtmlContent(html) {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;
        const plainText = tempDiv.textContent || tempDiv.innerText || "";
        return plainText.length > 40 ? plainText.slice(0, 40) + "..." : plainText;
      },
      goToProduct(prod) {
        const slug = prod.slug;
        this.$router.push({ name: "ProductDetail", params: { slug } });
      },

      formatPrice(value) {
        if (value == null || isNaN(value)) return '0,00';
        const num = Number(value) / 100;
        return num.toFixed(2).replace('.', ',');
      }
    },
  };
</script>

<style scoped>
  .product-card {
    text-align: left;
    height: 100% !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    max-width: 300px;
    margin: 0 auto;
  }

  .product-image {
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 10px;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
    background: #fff;
    position: relative;
    overflow: hidden;
  }

  .img-product {
    width: 100%;
    height: 200px;
    object-fit: contain;
    cursor: pointer;
  }

  .product-info {
    padding: 8px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }

  .gamme {
    font-size: 14px;
    font-weight: 300;
    color: #1e347d;
    min-height: 16px;
  }

  .title {
    font-size: 18px;
    font-weight: bold;
    color: #1e347d;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .desc {
    text-align: left;
    min-height: 40px;
    flex-grow: 1;
  }

  .desc label {
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .price {
    font-weight: bold;
    font-size: 15px;
    color: #1e347d;
    text-align: right;
  }

  .price span {
    font-size: 12px;
  }

  .product-more {
    background-color: #ec621a !important;
    border-radius: 76px;
    font-size: 14px;
    text-align: center;
  }

  .favorite {
    float: right;
    cursor: pointer;
    font-size: 20px;
    color: #1e347d;
  }

  @media (max-width: 992px) {
    .product-card {
      max-width: 250px;
    }

    .img-product {
      height: 150px;
    }

    .title {
      font-size: 16px;
    }

    .desc label {
      font-size: 12px;
    }

    .price {
      font-size: 13px;
    }
  }

  @media (max-width: 600px) {
    .product-card {
      max-width: 100%;
    }

    .product-image {
      padding: 6px; /* Réduit le padding sur mobile */
    }

    .img-product {
      height: 200px !important; /* Réduit la hauteur de l'image sur mobile */
      object-fit: contain !important;
    }

    .title {
      font-size: 14px;
    }

    .desc label {
      font-size: 11px;
    }

    .price {
      font-size: 12px;
    }

    .product-more {
      font-size: 12px;
      padding: 8px;
    }

    .favorite {
      font-size: 18px; /* Légère réduction de la taille de l'icône favori */
    }
  }

  /* Nouveau media query pour les très petits écrans */
  @media (max-width: 480px) {
    .product-card {
      max-width: 100%;
      margin: 0 4px; /* Réduit les marges latérales */
    }

    .product-image {
      padding: 4px; /* Encore moins de padding */
    }

    .img-product {
      height: 180px !important; /* Hauteur encore plus réduite pour très petits écrans */
      object-fit: contain !important;
    }

    .product-info {
      padding: 6px;
    }

    .gamme {
      font-size: 12px;
      min-height: 14px;
    }

    .title {
      font-size: 13px;
      margin-bottom: 4px;
    }

    .desc {
      min-height: 35px;
    }

    .desc label {
      font-size: 10px;
    }

    .price {
      font-size: 11px;
    }

    .price span {
      font-size: 10px;
    }

    .product-more {
      font-size: 11px;
      padding: 6px;
      margin-top: 8px;
    }

    .favorite {
      font-size: 16px;
    }
  }
</style>